module.exports = __webpack_public_path__ + "media/jàt maa ao bàep-bêrm nâ keu leu nâ.c4d4b4ca.mp3";